{
  "name": "@lskjs/creds",
  "version": "3.19.0",
  "description": "LSK.js CLI Creds is the easiest way to manage GitHub / Gitlab secrets and credentials",
  "author": "Igor Suvorov <hi@isuvorov.com> (https://github.com/isuvorov)",
  "private": false,
  "scripts": {
    "dev": "            lsk run dev",
    "build": "          lsk run build",
    "test": "           lsk run test",
    "prepack": "        lsk run prepack",
    "release": "        lsk run release"
  },
  "dependencies": {
    "@lskjs/algos": "^3.17.0",
    "@lskjs/cli-scripts": "^3.19.0",
    "@lskjs/cli-utils": "^3.17.0",
    "@lskjs/colors": "^3.17.0",
    "@lskjs/env": "^3.17.0",
    "@lskjs/err": "^3.17.0",
    "@lskjs/log": "^3.17.0",
    "@lskjs/stringify": "^3.19.0",
    "@types/node": "18.13.0",
    "axios": "^1.6.0",
    "fishbird": "^0.21.0",
    "libsodium-wrappers": "^0.7.13",
    "yargs": "^17.7.2"
  },
  "//": "///////////========================/////////========================/////////========================//////////",
  "prettier": "@lskjs/eslint-config/prettier",
  "eslintConfig": {
    "extends": "@lskjs/eslint-config"
  },
  "jest": {
    "preset": "@lskjs/jest-config"
  },
  "files": [
    "bin",
    "lib",
    "README.md",
    "LICENCE"
  ],
  "bin": {
    "lskcreds": "bin/run"
  },
  "main": "lib/index.js",
  "types": "lib/index.d.ts",
  "exports": {
    ".": {
      "import": "./lib/index.mjs",
      "types": "./lib/index.d.ts",
      "default": "./lib/index.js"
    },
    "./*": {
      "import": "./lib/*.mjs",
      "types": "./lib/*.d.ts",
      "default": "./lib/*.js"
    }
  },
  "///": "//////////========================/////////========================/////////========================/////////",
  "repository": "https://github.com/lskjs/lskjs/tree/master//libs-cli/lsk",
  "homepage": "https://github.com/lskjs/cli",
  "bugs": "https://github.com/lskjs/lskjs/issues",
  "license": "MIT",
  "publishConfig": {
    "access": "public",
    "registry": "https://registry.npmjs.org/"
  },
  "keywords": [
    "lskjs",
    "lsk",
    "cli",
    "helper"
  ],
  "////": "/////////========================/////////========================/////////========================/////////",
  "oclif": {
    "commands": "./lib/commands",
    "bin": "lsk",
    "plugins": [
      "@oclif/plugin-help"
    ]
  },
  "_scripts": {
    "postpack": "rm -f oclif.manifest.json",
    "prepack": "rm -rf lib && tsc -b && oclif-dev manifest && oclif-dev readme",
    "test": "echo skip",
    "build": "oclif-dev readme && git add README.md && echo ok"
  },
  "_size-limit": [
    {
      "//": "esm error",
      "path": "lib/index.js",
      "limit": "1kb"
    }
  ]
}
